import { useEffect, useState } from "react";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import { useMutation } from "@tanstack/react-query";

import { SubmitButton } from "ui-components/Form";
import { Layout } from "ui-components/Layout";
import { Success, Error_ } from "ui-components/Alert";
import { formRender, initialValues, shippingZoneValidation } from "./shipping-zone-schema";
import { createShippingZone } from "services/data.internal.service";
import ShippingZoneInfo from "./components/ShippingZoneInfo";

function AddShippingZone() {
  const [alert, setAlert] = useState(null);
  const onError = (data) => setAlert(<Error_ data={data} onChange={setAlert} />);

  const createShippingZoneMutation = useMutation(createShippingZone, {
    onSuccess: (data) => {
      setAlert(<Success data={data} onChange={setAlert} />);
    },
    onError,
  });
  const form = useForm({
    defaultValues: initialValues,
    resolver: yupResolver(shippingZoneValidation),
  });

  const {
    control,
    handleSubmit,
    formState: { errors, isSubmitting },
    reset,
  } = form;

  const infoProps = {
    control,
    errors,
    formRender,
  };
  const onSubmit = (data) => {
    window.scrollTo(0, 0);
    createShippingZoneMutation.mutate(data, {
      onSuccess: () => {
        reset();
      },
    });
  };
  return (
    <Layout>
      {alert}
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <ShippingZoneInfo {...infoProps} />
        <SubmitButton label="submit" disabled={isSubmitting} url="/setup/shipping-zone" />
      </form>
    </Layout>
  );
}

export default AddShippingZone;
